import { useMutation } from "@tanstack/react-query";
import { useContext } from "react";
import {
  createAccountApi,
  forgotPasswordApi,
  loginApi,
  resetPasswordApi,
  verifyResetCodeApi,
} from "../apis/authApi";
import { AuthContext } from "../provider";

export const useAuth = () => {
  return useContext(AuthContext);
};

export const useLogin = () => {
  return useMutation({
    mutationKey: ["login"],
    mutationFn: async ({ username, password, captchaResponse }) => {
      try {
        return await loginApi(username, password, captchaResponse);
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error.message ||
          "Nom d'utilisateur ou mot de passe invalide";

        throw new Error(message);
      }
    },
    onSuccess: (data) => {
      localStorage.setItem("authToken", data.token);
    },
    onError: (error) => {},
  });
};

export const useInscription = (options = {}) => {
  return useMutation({
    mutationKey: ["inscription"],
    mutationFn: async (data) => {
      return await createAccountApi(data);
    },
    onSuccess: (data) => {
      if (options.onSuccess) {
        options.onSuccess(data);
      }
    },
    onError: (error) => {
      let errorMessage =
        error?.response?.data?.message || error.message || "An error occurred";
      if (options.onError) {
        options.onError(errorMessage);
      }
    },
  });
};

export const useForgotPassword = () => {
  return useMutation({
    mutationKey: ["forgotPassword"],
    mutationFn: async ({ email }) => {
      return await forgotPasswordApi(email);
    },
    onError: (error) => {
      console.error(
        "Forgot Password request failed:",
        error.response?.data?.message || error.message
      );
    },
  });
};

export const useVerifyResetCode = () => {
  return useMutation({
    mutationKey: ["verifyResetCode"],
    mutationFn: async ({ email, verificationCode }) => {
      return await verifyResetCodeApi(email, verificationCode);
    },
    onError: (error) => {},
  });
};

export const useResetPassword = () => {
  return useMutation({
    mutationKey: ["resetPassword"],
    mutationFn: async ({ email, newPassword, confirmPassword }) => {
      return await resetPasswordApi(email, newPassword, confirmPassword);
    },
    onError: (error) => {
      console.error("Password reset failed:", error.message);
    },
  });
};
